import { FC } from 'react'
import { MeetingsHistoryTableContainer } from '../../meeting/shared/MeetingsHistoryTableContainer'
import { useTranslation } from 'react-i18next'
import { NextMeetingTile } from '../../dashboard/Tiles/Employee/NextMeetingTile'
import { EmployeeDisplayTinyInfo } from '../../../types'
import useReplyerMeetingsAndRequests from '../../../graphql/meeting/hooks/useReplyerMeetingsAndRequests'
import PerText from '../../../components/custom_components/Text'
import BackgroundBox from '../../../components/custom_components/BackgroundBox'
import { NewLoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors/NewLoadingAndErrors'

interface PublicMeetingsTabProps {
  employeeId: string
  employee?: EmployeeDisplayTinyInfo
  editable?: boolean
  resignedView?: boolean
}

export const PublicMeetingsTab: FC<PublicMeetingsTabProps> = ({ employeeId, editable = false, employee, resignedView }) => {
  const { t } = useTranslation()
  const { data, loading, error } = useReplyerMeetingsAndRequests(employeeId, resignedView)

  if (
    !resignedView &&
    (loading ||
      error ||
      !data ||
      !data.meetingsByReplyer ||
      !data.getMeetingRequestsByRequester ||
      !data.employeeDisplayShortInfoByEmployeeId)
  ) {
    return (
      <BackgroundBox r height="profileView">
        <NewLoadingAndErrors
          isLoading={loading}
          error={error}
          hasNoData={!data || !data.meetingsByReplyer || !data.getMeetingRequestsByRequester || !data.employeeDisplayShortInfoByEmployeeId}
          showSpinner
          t={t}
        />
      </BackgroundBox>
    )
  }

  return (
    <>
      {!resignedView && (
        <BackgroundBox height="infoBox" r mb="xs" className="slick--mx-xxl">
          <PerText mb="m" appearance="tile-heading">
            {t('dashboard.shared.meetings.header')}
          </PerText>
          <NextMeetingTile
            meetingData={data!.meetingsByReplyer!}
            employeeView
            withManagerOptions
            employeeId={employeeId}
            editable={editable}
            requestData={data!.getMeetingRequestsByRequester!}
            employeeName={data!.employeeDisplayShortInfoByEmployeeId!.firstName}
          />
        </BackgroundBox>
      )}

      <MeetingsHistoryTableContainer
        employeeId={employeeId}
        employee={employee}
        light
        emptyTextType="publicProfile"
        employeeIsEditable={editable}
        resignedView={resignedView}
        view="PublicMeetingsTab"
      />
    </>
  )
}
